import React, { useState, useImperativeHandle } from 'react';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { CommonCloudFirestore } from '../../../services/CommonCloudFirestore';
import { DOCUMENT_CATEGORY } from '../../../../shared/types/firestoreType';

import * as Yup from "yup";
import global from '../../../../shared/utility/global';

import './styles.css';

function Index(props, ref) {
    const categoryFirestore = new CommonCloudFirestore(DOCUMENT_CATEGORY);
    const [customPrice, setCustomPrice] = useState(false);
    const [categories, setCategories] = useState([]);
    const [priceRanges] = useState([
        { value: 1, name: "Cualquier Precio" },
        { value: 2, name: "Hasta S/. 1000.00" },
        { value: 3, name: "De S/. 1000.00 a S/. 2000.00" },
        { value: 4, name: "Más de S/. 2000.00" },
        { value: 5, name: "Personalizado" }
    ]);

    useImperativeHandle(ref, () => ({
        getValues: () => {
            var values = watch();
            values.priceRange = parseInt(values.priceRange);
            values.minPrice = values.minPrice === undefined || values.minPrice === "" ? undefined : parseFloat(values.minPrice);
            values.maxPrice = values.maxPrice === undefined || values.maxPrice === "" ? undefined : parseFloat(values.maxPrice);
            values.categoryIds = categories.filter(item => item.enable === true).map(m => m.id);
            return values;
        },
        setValue: setValue,
        onLoadCategories: onLoadCategories
    }));

    const schema = Yup.object().shape({});

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        watch
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            name: '',
            freeShipping: false,
            priceRange: '1'
        }
    });

    const onChangeCustomPrice = (e) => {
        if (e.target.value === '5')
            setCustomPrice(true);
        else
            setCustomPrice(false);

        setValue("priceRange", e.target.value);
        props.onSearch();
    };

    const onChangeCategory = (event) => {
        var filteredCategories = categories.map(m => {
            if (event.target.value == m.id)
                m.enable = event.target.checked;
            return m;
        });
        
        setCategories(filteredCategories.sort(global.orderBy('name')));
        props.onSearch();
    };

    const onLoadCategories = async (__products, productIds) => {
        var documents = await categoryFirestore.getDocuments();

        if (productIds !== undefined) {
            var _categories = [];
            var _products = __products.filter(m => productIds.includes(m.id));

            _products.forEach(element => {
                element.categories.forEach(item => {
                    var exist = _categories.filter(m => m === item).length;
                    if (exist === 0)
                        _categories.push(item);
                });
            });
            documents = documents.filter(m => _categories.includes(m.id));
        }

        setCategories(documents.map((m) => { return { ...m, enable: false } }).sort(global.orderBy('name')))
    };

    return (
        <form onSubmit={handleSubmit(props.onSearch)}>
            <div className='row'>
                {/* <div className='col-12' style={{ padding: '14px 20px 7px 20px', fontSize: '17px' }}>
                    <strong>Búsqueda</strong>
                </div>
                <div className='col-12' style={{ padding: '7px 20px' }}>
                    <div className="product-input-search">
                        <div className="input-group mb-3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Buscar aquí..."
                                {...register("name")}
                            />
                            <button
                                className="btn btn-primary"
                                type="button"
                                onClick={props.onSearch}
                            >
                                <i className="bi bi-search"></i>
                            </button>
                        </div>
                    </div>
                </div> */}
                <div className='col-12' style={{ padding: '5px 20px 10px 20px', fontSize: '17px' }}>
                    <strong>Precio</strong>
                </div>
                <div className='col-12' style={{ padding: '5px 20px 20px 20px', fontSize: '16px' }}>
                    {
                        priceRanges.map((item, index) => (
                            <div key={index} className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="priceRange"
                                    id={`priceRange${index + 1}`}
                                    value={item.value}
                                    {...register("priceRange")}
                                    onChange={onChangeCustomPrice}
                                />
                                <label className="form-check-label" htmlFor={`priceRange${index + 1}`}>{item.name}</label>
                            </div>
                        ))
                    }
                </div>

                {
                    customPrice ?
                        <div className='col-12' style={{ padding: '0px 20px 20px 20px', fontSize: '16px' }}>
                            <div className='mb-15'>
                                <label className="form-label">Mínimo</label>
                                <input
                                    id="minPrice" {...register("minPrice")}
                                    type="text"
                                    className="form-control"
                                    placeholder="0.00"
                                    onKeyPress={global.onKeyPressDecimals}
                                    onBlur={(e) => setValue("minPrice", global.onBlurFilterDecimals(e, 2))}
                                    onKeyUp={(e) => {
                                        if (e.keyCode === 13) {
                                            props.onSearch();
                                        }
                                    }}
                                />
                            </div>

                            <label className="form-label">Máximo</label>
                            <div className="input-group mb-3">
                                <input
                                    id="maxPrice" {...register("maxPrice")}
                                    type="text"
                                    className="form-control"
                                    placeholder="0.00"
                                    onKeyPress={global.onKeyPressDecimals}
                                    onBlur={(e) => setValue("maxPrice", global.onBlurFilterDecimals(e, 2))}
                                    onKeyUp={(e) => {
                                        if (e.keyCode === 13) {
                                            props.onSearch();
                                        }
                                    }}
                                />
                                <button
                                    className="btn btn-primary"
                                    type="maxPrice"
                                >
                                    <i className="bi bi-search"></i>
                                </button>
                            </div>
                        </div> : null
                }
                <div className='col-12' style={{ padding: '0px 20px 10px 20px', fontSize: '17px' }}>
                    <strong>Envío</strong>
                </div>
                <div className='col-12' style={{ padding: '0px 20px', fontSize: '16px' }}>
                    <div className="form-check">
                        <input
                            id="freeShipping" {...register("freeShipping")}
                            type="checkbox"
                            className="form-check-input"
                            onChange={(e) => {
                                setValue("freeShipping", e.target.checked);
                                props.onSearch();
                            }}
                        />
                        <label className="form-check-label" htmlFor="freeShipping" style={{ color: '#107c10' }}>
                            <strong>Envío gratis</strong>
                        </label>
                    </div>
                </div>
                <div className='col-12' style={{ padding: '15px 20px 10px 20px', fontSize: '17px' }}>
                    <strong>Categorías</strong>
                </div>
                {
                    categories.map((item, index) => (
                        <div key={index} className='col-12' style={{ padding: '5px 20px', fontSize: '16px' }}>
                            <div className="form-check">
                                <input
                                    id={`categoryIds${index + 1}`}
                                    className="form-check-input"
                                    type="checkbox"
                                    name="categoryIdsGroup"
                                    value={item.id}
                                    onChange={onChangeCategory}
                                />
                                <label className="form-check-label" htmlFor={`categoryIds${index + 1}`}>{item.name}</label>
                            </div>
                        </div>
                    ))
                }
            </div>
        </form>
    );
}
export default React.forwardRef(Index);